import i18n from '@/helpers/i18n'

export const QualityList = {
  data() {
    return {
      qualityList: [
        { text: i18n.instance().t('label-organizer-quality-volunteer'), id: 0 },
        { text: i18n.instance().t('label-organizer-quality-employee'), id: 1 },
        { text: i18n.instance().t('label-organizer-quality-contract'), id: 2 },
        { text: i18n.instance().t('label-organizer-quality-entrepreneur'), id: 3 },
        { text: i18n.instance().t('label-organizer-quality-other'), id: 4 }
      ]
    }
  },
  computed: {
    qualities: function() {
      return this.qualityList
    }
  },
  methods: {
    getQualityLabelById: function(id) {
      return this.qualityList.filter(x => x.id === id).first().text
    }
  }
}
